import type { ReactElement } from 'react';
import { Grid } from './Grid';
import { BonusLinkerProps } from './types';
import { FilterForm, useFilterState } from '../filter';
import { HeaderRow } from './HeaderRow';
import { FilterRow } from './FilterRow';
import { Submit, useForm } from '@ff-it/form';
import { useLinkerState } from './useLinkerState';
import { LinkerSummary } from '../LinkerSummary';
import { Box } from '@ff-it/ui';
import { Export } from './Export';
import { calcSummaryState } from './calcSummaryState';
import { Portal } from 'components/Portal';

export function BonusLinker({ disabled = false, invoice, direction, url, ...props }: BonusLinkerProps): ReactElement {
  const form = useForm();
  const [filterState, setFilterState] = useFilterState();
  const { rows, bound } = useLinkerState(props, filterState, disabled);
  const summary = calcSummaryState(rows, bound, invoice);
  const unlink =
    !disabled && summary.hasBound
      ? () => {
          form.change('bound', {});
        }
      : undefined;

  const link =
    !disabled && summary.hasAvailable
      ? () => {
          form.change('bound', {
            ...bound,
            ...rows.reduce((acc: Record<string, string>, { id, bound, balance }) => {
              const key = `_${id}`;
              if (bound === null && !balance.eq(0)) {
                acc[key] = balance.toFixed();
              }
              return acc;
            }, {}),
          });
        }
      : undefined;
  return (
    <>
      <Portal>
        <Export url={url} />
        {!disabled && <Submit className="ml-3" size="sm" />}
        {invoice && (
          <Box marginLeft="auto" className="pr-1">
            <LinkerSummary direction={direction} state={summary} mb="1" />
          </Box>
        )}
      </Portal>
      <HeaderRow />
      <FilterForm filter={filterState} setFilter={setFilterState} disabled={false}>
        <FilterRow entities={props.entities} summary={summary} unlink={unlink} link={link} />
      </FilterForm>
      <Grid rows={rows} entities={props.entities} disabled={disabled} />
    </>
  );
}
